var _symbol, _g, _path, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmokeKill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32.074px",
    height: "32.074px",
    viewBox: "0 0 32.074 32.074",
    enableBackground: "new 0 0 32.074 32.074",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dude-transit",
    viewBox: "0 -25.1 21.25 25.118"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M15.5-4.2l0.75-1.05l1-3.1l3.9-2.65v-0.05 c0.067-0.1,0.1-0.233,0.1-0.4c0-0.2-0.05-0.383-0.15-0.55c-0.167-0.233-0.383-0.35-0.65-0.35l-4.3,1.8l-1.2,1.65l-1.5-3.95 l2.25-5.05l-3.25-6.9c-0.267-0.2-0.633-0.3-1.1-0.3c-0.3,0-0.55,0.15-0.75,0.45c-0.1,0.133-0.15,0.25-0.15,0.35 c0,0.067,0.017,0.15,0.05,0.25c0.033,0.1,0.067,0.184,0.1,0.25l2.55,5.6L10.7-14l-3.05-4.9L0.8-18.7 c-0.367,0.033-0.6,0.184-0.7,0.45c-0.067,0.3-0.1,0.467-0.1,0.5c0,0.5,0.2,0.767,0.6,0.8l5.7,0.15l2.15,5.4l3.1,5.65L9.4-5.6 c-1.367-2-2.1-3.033-2.2-3.1C7.1-8.8,6.95-8.85,6.75-8.85C6.35-8.85,6.1-8.667,6-8.3C5.9-8,5.9-7.8,6-7.7H5.95l2.5,4.4l3.7,0.3 L14-3.5L15.5-4.2z M14.55-2.9c-0.333,0.4-0.45,0.85-0.35,1.35c0.033,0.5,0.25,0.9,0.65,1.2c0.4,0.3,0.85,0.417,1.35,0.35 c0.5-0.067,0.9-0.3,1.2-0.7c0.333-0.4,0.467-0.85,0.4-1.35c-0.066-0.5-0.3-0.9-0.7-1.2c-0.4-0.333-0.85-0.45-1.35-0.35 C15.25-3.533,14.85-3.3,14.55-2.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "topo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M24.126,13.219c0.061-0.28,0.094-0.57,0.094-0.868c0-2.229-1.807-4.035-4.035-4.035 c-0.62,0-1.208,0.14-1.733,0.391c-0.47-1.822-2.124-3.168-4.093-3.168c-2.334,0-4.226,1.892-4.226,4.226 c0,0.235,0.02,0.464,0.057,0.689c-0.407-0.214-0.871-0.336-1.363-0.336c-1.623,0-2.939,1.316-2.939,2.939 c0,0.631,0.2,1.213,0.538,1.692c-2.385,0.345-4.218,2.398-4.218,4.879c0,2.723,2.207,4.931,4.931,4.931 c1.11,0,2.134-0.367,2.957-0.985c0.811,0.404,1.725,0.633,2.692,0.633c1.221,0,2.358-0.364,3.308-0.987 c1.066,0.942,2.465,1.515,4,1.515c1.639,0,3.124-0.653,4.213-1.713c2.431-0.304,4.313-2.377,4.313-4.891 C28.623,15.552,26.646,13.438,24.126,13.219z M15.605,14.831c-0.078,0.318-0.405,0.514-0.719,0.435 c-1.175-0.286-1.924,0.285-2.27,0.653c-0.608,0.646-0.845,1.562-0.604,2.332c0.078,0.251-0.018,0.524-0.236,0.67 c-0.218,0.147-0.506,0.133-0.709-0.034c-0.335-0.276-1.125-0.499-1.749-0.196c-0.72,0.348-0.853,1.277-0.838,1.994 c0.007,0.329-0.254,0.6-0.582,0.606c-0.005,0-0.008,0-0.012,0c-0.323,0-0.588-0.258-0.594-0.582 c-0.041-2.033,0.929-2.807,1.509-3.088c0.627-0.304,1.329-0.319,1.939-0.171c0.045-0.846,0.4-1.694,1.013-2.345 c0.89-0.946,2.133-1.308,3.42-0.992C15.489,14.191,15.684,14.513,15.605,14.831z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.658,
    y: 10.64,
    fill: "#FFFFFF",
    width: 2.591,
    height: 0.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.907,
    y: 8.898,
    transform: "matrix(0.7026 -0.7116 0.7116 0.7026 2.022 23.3421)",
    fill: "#FFFFFF",
    width: 2.057,
    height: 0.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.801,
    y: 11.791,
    transform: "matrix(0.7032 -0.711 0.711 0.7032 -0.4614 24.534)",
    fill: "#FFFFFF",
    width: 0.707,
    height: 2.058
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.367,
    y: 12.681,
    transform: "matrix(0.9028 -0.43 0.43 0.9028 -3.0539 13.2196)",
    fill: "#FFFFFF",
    width: 0.708,
    height: 1.371
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.983,
    y: 8.23,
    transform: "matrix(0.5382 -0.8428 0.8428 0.5382 5.543 27.2831)",
    fill: "#FFFFFF",
    width: 1.371,
    height: 0.707
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.037,12.013l7.63,0.004l2.054-1.137l-2.164-1.042h-7.521V12.013z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.0374,
    y1: 10.9091,
    x2: 15.8948,
    y2: 10.9091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.895,
    y: 9.838,
    fill: "url(#SVGID_1_)",
    width: 2.143,
    height: 2.143
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeKill);
export default __webpack_public_path__ + "static/media/smoke_kill.2c5f4d1ba06aca051f7881295da8269f.svg";
export { ForwardRef as ReactComponent };